import * as tslib_1 from "tslib";
import { Vue, Component, Prop } from 'vue-property-decorator';
import SingleCoup from './singleCoup.vue';
let BagPop = class BagPop extends Vue {
    async mounted() {
        await this.$nextTick();
        let app = document.querySelector('.preview-box');
        app.classList.add('stopmove');
    }
    close() {
        let app = document.querySelector('.preview-box');
        app.classList.remove('stopmove');
        this.$emit('update:showBagPop', false);
    }
    updateCoupons() {
        this.$emit('updateCoupons');
    }
    clickEvent() {
        this.$emit('clickEvent');
    }
};
tslib_1.__decorate([
    Prop({ default: () => { } })
], BagPop.prototype, "publicParams", void 0);
tslib_1.__decorate([
    Prop()
], BagPop.prototype, "showBagPop", void 0);
tslib_1.__decorate([
    Prop()
], BagPop.prototype, "bagCoupInfos", void 0);
tslib_1.__decorate([
    Prop()
], BagPop.prototype, "bagFailList", void 0);
tslib_1.__decorate([
    Prop()
], BagPop.prototype, "pageId", void 0);
BagPop = tslib_1.__decorate([
    Component({
        components: {
            SingleCoup,
        },
    })
], BagPop);
export default BagPop;
